export default __webpack_public_path__ + "static/media/navbar-services-dark.d6331a17.svg";